import React from 'react';
import { Star, Quote, MapPin } from 'lucide-react';
import { SectionReveal, StaggerContainer, StaggerItem } from './SectionReveal';
const testimonials = [{
  name: 'Martín Gutiérrez',
  initials: 'MG',
  city: 'Buenos Aires',
  text: 'La verdad que no tenía ni idea de mecánica. Después de leer el Tomo 5 fui al taller y por primera vez entendí lo que me estaban cobrando. Me ahorré como $80.000 en una reparación que no necesitaba.',
  accent: 'from-amber-500 to-orange-600'
}, {
  name: 'Carolina Pérez',
  initials: 'CP',
  city: 'Córdoba',
  text: 'Compré el pack porque me iba a comprar un usado y tenía miedo de que me metan un auto malo. El Tomo 6 y el Manual Express me salvaron, fui a ver un Corsa y descarté tres antes de elegir uno bueno.',
  accent: 'from-amber-400 to-amber-600'
}, {
  name: 'Javier Sosa',
  initials: 'JS',
  city: 'Rosario',
  text: 'El Tomo 2 me cambió la vida. Antes me asustaba cada lucecita del tablero y salía corriendo al mecánico. Ahora sé cuáles son urgentes y cuáles puedo manejar yo mismo. Súper recomendado.',
  accent: 'from-orange-500 to-amber-600'
}, {
  name: 'Lucía Fernández',
  initials: 'LF',
  city: 'Mendoza',
  text: 'Soy mujer y siempre sentí que en los talleres me querían vender cualquier cosa. Con este material aprendí a comparar presupuestos y plantarme mejor. Muy bien explicado, sin palabras raras.',
  accent: 'from-amber-500 to-yellow-600'
}, {
  name: 'Diego Romero',
  initials: 'DR',
  city: 'Mar del Plata',
  text: 'Hago muchos viajes largos por trabajo y el Tomo 3 más el Checklist Previaje me dan tranquilidad. Tuve una pinchadura en la ruta y lo resolví yo solo sin llamar al auxilio. Vale cada peso.',
  accent: 'from-amber-600 to-orange-700'
}];
export function TestimonialsSection() {
  return <section className="py-20 md:py-32 bg-[#0a0a0a] border-b border-[#262626]" data-id="element-261">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-262">
        <SectionReveal className="text-center mb-16" data-id="element-263">
          <div className="inline-block border border-[#F59E0B]/30 bg-[#F59E0B]/10 text-[#F59E0B] font-heading text-xs md:text-sm tracking-[0.2em] px-3 py-1 rounded-sm mb-6" data-id="element-264">
            HISTORIAS REALES · ARGENTINA
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-265">
            Lo que dicen quienes ya{' '}
            <span className="text-[#F59E0B]" data-id="element-266">aprendieron</span>
          </h2>
          <div className="flex items-center justify-center gap-2 mt-6" data-id="element-267">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#F59E0B] text-[#F59E0B]" data-id="element-268" />)}
            <span className="ml-2 text-[#9CA3AF] font-medium text-sm" data-id="element-269">
              +1.200 lectores satisfechos
            </span>
          </div>
        </SectionReveal>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-270">
          {testimonials.map((t, idx) => <StaggerItem key={idx} className={`bg-[#171717] border border-[#262626] rounded-sm p-7 hover:border-[#F59E0B]/40 transition-all duration-300 relative ${idx === 2 ? 'lg:col-span-1' : ''} ${idx === 3 ? 'lg:col-start-1' : ''}`} data-id="element-271">
              <Quote className="absolute top-4 right-4 w-8 h-8 text-[#262626]" data-id="element-272" />

              <div className="flex gap-1 mb-4" data-id="element-273">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#F59E0B] text-[#F59E0B]" data-id="element-274" />)}
              </div>

              <p className="text-[#F5F5F5] leading-relaxed mb-6 text-sm md:text-base" data-id="element-275">
                "{t.text}"
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-[#262626]" data-id="element-276">
                <div className={`w-11 h-11 rounded-full bg-gradient-to-br ${t.accent} flex items-center justify-center font-heading font-bold text-[#0a0a0a] text-sm flex-shrink-0`} data-id="element-277">
                  {t.initials}
                </div>
                <div data-id="element-278">
                  <div className="text-white font-medium text-sm" data-id="element-279">{t.name}</div>
                  <div className="flex items-center gap-1 text-[#9CA3AF] text-xs mt-0.5" data-id="element-280">
                    <MapPin className="w-3 h-3 text-[#F59E0B]" data-id="element-281" />
                    {t.city}, Argentina
                  </div>
                </div>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}